module.exports = __webpack_public_path__ + "media/images/lp/sv/img/pc/icatch-bg2-8815cf41f23fc07b9e6f3481e3852df7.jpg";